import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaTools, FaPaintRoller, FaLayerGroup, FaThLarge, FaRoad, FaFaucet } from 'react-icons/fa';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'flooring installation':
      return <FaLayerGroup />; // Layered flooring

    case 'tile installation':
      return <FaThLarge />; // Tiled layout

    case 'paving services':
      return <FaRoad />; // Road/pavement

    case 'floor repair':
      return <FaTools />; // Repair tools

    case 'grout cleaning':
      return <FaFaucet />; // Water/cleaning

    case 'concrete polish':
      return <FaPaintRoller />; // Surface finishing

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadspecialist':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    default:
      return null; // Return null if no matching icon is found
  }

};